import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

interface Activity {
  punchInTime: string;
  punchOutTime?: string;
  sessionStatus: string;
  workingHours: number;
}

interface DayAttendance {
  status: "present" | "absent" | "half" | string;
  workingHours: number;
  notes: string;
  recordId: string | null;
  activities: Activity[];
}

interface AttendanceRecord {
  employee: {
    id: string;
    name: string;
    email: string;
  };
  attendance: Record<string, DayAttendance>;
}

interface AttendanceResponse {
  success: boolean;
  data: {
    month: string;
    year: string;
    daysInMonth: number;
    attendanceData: AttendanceRecord[];
  };
}

const getAttendanceAdmin = async (
  month: number,
  year: number
): Promise<AttendanceResponse> =>
  (
    await customAxios.get<AttendanceResponse>(
      `/attendance/admin?type=month&month=${month}&year=${year}`
    )
  ).data;

export const useGetAttendanceAdmin = (month: number, year: number) =>
  useQuery<AttendanceResponse, AxiosError>(
    ["admin-attendance", month, year],
    () => getAttendanceAdmin(month, year),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Attendance Data",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load attendance data",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
